export class AdminCreationDatamodel {
    constructor(
    public roles : string[],
    public areaOfFocus : string[]
  ) {}
}
